import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, of, throwError} from "rxjs";
import {KeyLocalStorage} from "../models/enum/emun-enumeracion";
import {inject} from "@angular/core";
import {ConexionRedService} from "../services/conexion-red.service";
import {getOfflineHttpResponse} from "../../util/retry-with-network-aware";
import {AppInfoService} from "../services/app-info.service";

export const interceptorErrorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const conexionRedService = inject(ConexionRedService);
  const appInfAppSer = inject(AppInfoService);
  // const token = appInfAppSer?.usuarioLogeado?.accessToken;
  // 1. Validar si hay red antes de siquiera intentar la petición
  if (!conexionRedService.isOnline()) {
    // Devuelve una respuesta vacía sin disparar error
    return of(getOfflineHttpResponse({ offline: true }));
  }

  // 2. Clonamos la petición para añadir los headers necesarios
  const authReq = req.clone({
    setHeaders: {
      'Content-Type': 'application/json'
    }
  });

  // const authReq = req.clone({
  //   setHeaders: {
  //     'Content-Type': 'application/json',
  //     ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  //   }
  // });
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si no hay red, evitamos pasar la petición
      if (!conexionRedService.isOnline()) {
        // Devuelve una respuesta vacía sin disparar error
        return of(getOfflineHttpResponse({ offline: true }));
      }
      // 🔹 Si fue otro tipo de error real (500, 404, etc.)
      return throwError(() => getErrorPeticiones(error));
    })
  );
};

function getErrorPeticiones(error: HttpErrorResponse): string {
  const lenguaje: string = localStorage.getItem(KeyLocalStorage.Lenguaje);
  const esES: boolean = lenguaje === 'es';
  let resultMsjError: string;
  const msjError0 = `<strong><em>Error ${error.status} - Unknown Error</em></strong><br>
                              <strong><em>Possible cause: </em></strong>The request might be blocked due to CORS policies on the server-side or browser restrictions or The client may not have an active internet connection or there could be intermittent network issues.<br>
                              <strong><em>Possible solution: </em></strong>Ensure that CORS headers (Access-Control-Allow-Origin, etc.) are correctly configured on the server to allow requests from your domain or Verify that the client has a stable and active internet connection.`;
  const msjError4XX = `<strong><em>Error ${error.status} - Forbidden</em></strong><br>
                              <strong><em>Possible cause: </em></strong>Incorrect access permissions or lack of permissions to access the resource.<br>
                              <strong><em>Possible solution: </em></strong>Adjust server permissions to allow access to necessary resources.`;
  const msjError404 = `<strong><em>Error ${error.status} - Page Not Found</em></strong><br>
                              <strong><em>Possible cause: </em></strong>The requested URL does not exist or has been deleted.<br>
                              <strong><em>Possible solution: </em></strong>Verify and correct broken links. Set up 301 redirects if the page has been moved.`;
  const msjError500 = `<strong><em>Error ${error.status} -  Internal Server Error</em></strong><br>
                              <strong><em>Possible cause: </em></strong>Server problems, poorly written code, or incorrect configurations.<br>
                              <strong><em>Possible solution: </em></strong>Check server logs to identify the specific problem. Ensure the server has enough capacity and that the code is error-free.`;
  const msjError502 = `<strong><em>Error ${error.status} - Bad Gateway</em></strong><br>
                              <strong><em>Possible cause: </em></strong>Communication problems between servers or the proxy server.<br>
                              <strong><em>Possible solution: </em></strong>Verify proxy or gateway settings. Ensure backend servers are functioning correctly.`;
  const msjError503 = `<strong><em>Error ${error.status} - Service Unavailable</em></strong><br>
                              <strong><em>Possible cause: </em></strong>The server is overloaded or undergoing maintenance.<br>
                              <strong><em>Possible solution: </em></strong>Optimize server performance. Set up a maintenance page to inform users.`;
  switch (error.status) {
    case 0:
      resultMsjError = esES ?
        `<strong><em>Error ${error.status} - Error desconocido</em></strong><br>
         <strong><em>Posible causa: </em></strong>La solicitud puede bloquearse debido a políticas CORS en el lado del servidor o restricciones del navegador o Es posible que el cliente no tenga una conexión a Internet activa o que haya problemas de red intermitentes.<br>
         <strong><em>Posible solución: </em></strong>Asegúrese de que los encabezados CORS (Access-Control-Allow-Origin, etc.) estén configurados correctamente en el servidor para permitir solicitudes de su dominio o Verifique que el cliente tenga una conexión a Internet estable y activa.` :
        msjError0;
      break;
    case 400:
    case 401:
    case 402:
    case 403:
      resultMsjError = esES ?
        `<strong><em>Error ${error.status} - Prohibido</em></strong><br>
         <strong><em>Posible causa: </em></strong>Permisos de acceso incorrectos o falta de permisos para acceder al recurso.<br>
         <strong><em>Posible solución: </em></strong>Ajusta los permisos del servidor para permitir el acceso a los recursos necesarios.` :
        msjError4XX;
      break;
    case 404:
      resultMsjError = esES ?
        `<strong><em>Error ${error.status} - Página no Encontrada</em></strong><br>
         <strong><em>Posible causa: </em></strong>La URL solicitada no existe o ha sido eliminada.<br>
         <strong><em>Posible solución: </em></strong>Verifica y corrige enlaces rotos. Configura redireccionamientos 301 si la página ha sido movida.` :
        msjError404;
      break;
    case 500:
      resultMsjError = esES ?
        `<strong><em>Error ${error.status} - Error Interno del Servidor</em></strong><br>
         <strong><em>Posible causa: </em></strong>Problemas en el servidor, código mal escrito o configuraciones incorrectas.<br>
         <strong><em>Posible solución: </em></strong>Revisa los logs del servidor para identificar el problema específico. Asegúrate de que el servidor tenga suficiente capacidad y que el código esté libre de errores.` :
        msjError500;
      break;
    case 502:
      resultMsjError = esES ?
        `<strong><em>Error ${error.status} - Puerta de enlace incorrecta</em></strong><br>
         <strong><em>Posible causa: </em></strong>Problemas de comunicación entre servidores o el servidor proxy.<br>
         <strong><em>Posible solución: </em></strong>Verifica la configuración del proxy o gateway. Asegúrate de que los servidores backend estén funcionando correctamente.` :
        msjError502;
      break;
    case 503:
      resultMsjError = esES ?
        `<strong><em>Error ${error.status} - Servicio No Disponible</em></strong><br>
         <strong><em>Posible causa: </em></strong>El servidor está sobrecargado o en mantenimiento.<br>
         <strong><em>Posible solución: </em></strong>Optimiza el rendimiento del servidor. Configura una página de mantenimiento para informar a los usuarios.` :
        msjError503;
      break;
    default:
      resultMsjError = `<strong><em>Error ${error.status} - ${error.statusText}</em></strong><br>${error.message}`;
  }

  return resultMsjError;
}
